import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { grid } from '@noths/polaris-client-ribbons-base';

import { ContentTile } from './ContentTile';
import { ContentTileAspectRatioSizes } from './ContentTileAspectRatioSizes';
import type { ContentTilesProps } from './types';
import { getImgSourcesByBreakpoint } from './utils';
import * as styles from './ContentTiles.styles';

export const ContentTiles = ({ onTileClick, onVisible = () => {}, tiles }: ContentTilesProps) => {
  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  const isFourTileLayout = tiles.length !== 2;
  const aspectRatioLayoutStyle = isFourTileLayout
    ? ContentTileAspectRatioSizes.fourTileLayout
    : ContentTileAspectRatioSizes.twoTileLayout;

  return (
    <div css={[grid, styles.grid]} ref={observedElementRef}>
      {tiles.map(({ backgroundColor, href, imageSrc, title }, index) => {
        const imgSourcesByBreakpoint = getImgSourcesByBreakpoint(imageSrc, aspectRatioLayoutStyle);

        return (
          <ContentTile
            backgroundColor={backgroundColor}
            href={href}
            imgSourcesByBreakpoint={imgSourcesByBreakpoint}
            isFourTileLayout={isFourTileLayout}
            key={href}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => onTileClick?.(e, { index })}
            title={title}
          />
        );
      })}
    </div>
  );
};
